import { Route, Routes } from "react-router-dom";
import { UserRoles } from "../../../constants/userRoles";
import { PrivateRoute } from "../../../keycloak";
import { LeadCreate } from "./LeadCreate/LeadCreate";
import { LeadList } from "./LeadList/LeadList";
import { LeadView } from "./LeadView";

export const SalesLead = () => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.LEAD_VIEW],
            }}
          />
        }
      >
        <Route index path="/" element={<LeadList />} />
      </Route>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.LEAD_CREATE],
            }}
          />
        }
      >
        <Route path={`/create`} element={<LeadCreate />} />
      </Route>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.LEAD_VIEW],
            }}
          />
        }
      >
        <Route path={`/:leadId/*`} element={<LeadView />} />
      </Route>
    </Routes>
  );
};
